<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Forgot password</h1>
      <p>
        To reset your password, please enter the currently valid email address
        for your Porsche Auto Insurance account:
      </p>

      <form
        class="form has-placeholders"
        @submit.prevent="validateBeforeSubmit"
      >
        <fieldset>
          <div class="columns is-variable is-8">
            <div class="column is-7-desktop is-8-tablet">
              <label class="input">
                <input
                  :class="{
                    input__field: true,
                    error: errors.has('email')
                  }"
                  name="email"
                  type="email"
                  placeholder="Email Address*"
                  v-model="email"
                  v-validate="'required|email'"
                  data-vv-name="email"
                  data-vv-as="Email Address"
                />
                <span class="input__label">Email Address*</span>
              </label>
            </div>

            <div class="column is-3-desktop is-4-tablet">
              <button
                type="submit"
                class="button-primary  button-primary--black button-primary--stretch"
              >
                <span class="button-primary__icon icon icon--arrow-right-hair">
                  <span class="loader-base button-primary__loader"></span>
                </span>

                <span class="button-primary__label">Reset Password</span>
              </button>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'ForgotPassword',
  data: () => ({
    email: ''
  }),
  methods: {
    ...mapActions(['resetPassword']),
    ...mapMutations(['toggleLoader']),
    validateBeforeSubmit() {
      let firstErrorField;
      let email = this.email;
      const returnUrl = window.location.origin + '/account/create-password';
      let payload = {
        email: email,
        returnUrl: returnUrl
      };

      this.$validator.validateAll().then(result => {
        if (result) {
          this.toggleLoader({
            loaderText: 'Loading...'
          });
          this.resetPassword(payload)
            .then(() => {
              this.toggleLoader();
              this.showSnackBar({
                type: 'is-success',
                message: 'Sent a link to reset your password',
                position: 'is-bottom'
              });
              this.$router.push('/');
            })
            .catch(() => {
              this.toggleLoader();
              this.showSnackBar({
                type: 'is-danger',
                message: '',
                position: 'is-bottom'
              });
              let message = document.querySelector('.snackbar > .text');
              message.innerHTML = `The system is unable to complete your request at this time. 
              Please call <nobr><a style="text-decoration:underline;color:#fff" href="tel:1-800-400-4128">800-400-4128</a></nobr> 
              to speak to a customer service concierge.`;
            });
          return;
        }

        firstErrorField = this.$el.querySelector(
          '[name="' + this.$validator.errors.items[0].field + '"]'
        );
        firstErrorField.focus();
      });
    },
    showSnackBar(options) {
      this.$snackbar.open(options);
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: 3rem;

  @media (min-width: 1000px) {
    margin-bottom: 20rem;
  }
}

p {
  @media (min-width: 1000px) {
    max-width: 900px;
  }
}
</style>
